<div [formGroup]="formGroup()" class="border-form-control rounded position-relative">
    <label [for]="id()" [id]="id() + '-label'"
        class="position-absolute primary-bg-150 primary-text-200 px-1 font-4 form-label">{{label()}}<span
            *ngIf="required()" class="text-red-500"> *</span></label>

    <select [formControlName]="id()" class="p-3 bg-transparent border-0 primary-text w-100">

        <option class="text-black" disabled value="" selected>Select Room Type</option>

        @for(type of types(); track type)
        {
        <option [value]="type.id" class="text-black">
            <type-item [type]="type" />
        </option>
        }
        @empty
        {
        <!-- add unselectable empty option -->
        <option class="text-black" value="" disabled selected>No room type available</option>
        }
    </select>
</div>